export default __webpack_public_path__ + "static/media/faceB-victory.69c18634.png";